// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"698ae75e","213":"792dc24a","239":"042ab8b0","453":"b8cd1c83","455":"9038368b","557":"c0443f46"}[chunkId] + ".chunk.js";
};